/**
 * @fileoverview When to reload the signed-in person's menu after an
 * administrator may have changed their access: on coming back to the tab, at
 * most once per interval, so a change shows up without signing in again.
 */

export interface AccessRefreshDeps {
  /** Milliseconds since an epoch; injected so the spec controls time. */
  now: () => number;
  /** The shortest gap between two reloads. */
  minIntervalMs: number;
}

export class AccessRefreshPolicy {
  private lastRefresh: number;

  constructor(private readonly deps: AccessRefreshDeps) {
    this.lastRefresh = deps.now();
  }

  /** The tab came back into view: reload only if the last one is old enough. */
  onFocus(): boolean {
    const now = this.deps.now();
    if (now - this.lastRefresh < this.deps.minIntervalMs) return false;
    this.lastRefresh = now;
    return true;
  }
}
